module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Movie-lane#1-cbd5ac87511b78b7d5e74b31f6f27176.svg";